
export enum PlantClassification {
  SUCCULENTS_CACTI = 'Suculentas e cactos',
  TROPICAL_FOLIAGE = 'Folhagens tropicais',
  ORCHIDS = 'Orquídeas',
  TREES_SHRUBS = 'Árvores e arbustos',
  AQUATIC = 'Plantas aquáticas',
  EDIBLE_GARDEN = 'Horta comestível',
  CAUDICIFORM = 'Caudiciforme',
  MEDICINAL = 'Medicinal',
}

export enum PlantKingdom {
  BRIOFITAS = 'Briófitas',
  PTERIDOFITAS = 'Pteridófitas',
  GIMNOSPERMAS = 'Gimnospermas',
  ANGIOSPERMAS = 'Angiospermas',
}

export enum PlantStatus {
  HEALTHY = 'Saudável',
  OBSERVATION = 'Observação',
  SICK = 'Doente',
}

export enum SunExposure {
  FULL_SUN = 'Sol pleno',
  PARTIAL_SHADE = 'Meia-sombra',
  SHADE = 'Sombra',
}

export interface UserPreferences {
  tema: 'light' | 'dark';
  idioma: 'pt-BR' | 'en';
}

export interface UserProfile {
  uid: string;
  nome: string;
  email: string;
  dataCriacao: any;
  atualizadoEm?: any;
  preferencias: UserPreferences;
  idade?: string;
  cpf?: string;
  telefone?: string;
  endereco?: string;
  cidade?: string;
  estado?: string;
  cep?: string;
  photoUrl?: string;
  photoFileName?: string;
}

export interface PlanoManejo {
  rega: string;
  adubacao: string;
  poda: string;
  tipoAdubo?: string;
  exposicaoSolar?: SunExposure;
}

export interface Tratamento {
  medicacao: string;
  controlePragas: string;
  instrucoesEspeciais: string;
}

export interface Localizacao {
  latitude: number;
  longitude: number;
  descricao?: string;
}

export interface Reminders {
  watering: boolean;
  fertilizing: boolean;
  pruning: boolean;
  repotting: boolean;
}

export interface Plant {
  id: string;
  userId: string;
  nomeComum: string;
  nomeCientifico: string;
  genero?: string;
  familia?: string;
  categoria: PlantClassification;
  reinoPlantae?: PlantKingdom;
  dataAquisicao: string;
  origem: 'comprada' | 'coletada' | 'cultivada' | 'clone' | 'semeio' | 'presente';
  observacoes: string;
  planoManejo: PlanoManejo;
  tratamento: Tratamento;
  status: PlantStatus;
  localizacao: Localizacao;
  imagens: string[];
  reminders: Reminders; 
  ultimaRega?: string;
  criadoEm: any;
  atualizadoEm: any;
}

export type ViewMode = 'list' | 'grid' | 'cards';

export type SubscriptionStatus = 'active' | 'canceled' | 'past_due' | 'trialing' | 'incomplete' | 'incomplete_expired' | 'unpaid' | 'paused';

export interface Subscription {
  id: string;
  user_id: string;
  status: SubscriptionStatus;
  stripe_customer_id?: string;
  stripe_subscription_id?: string;
  plan_type: 'monthly' | 'yearly';
  current_period_end: string;
  created_at: string;
  updated_at: string;
}
